module.exports = __webpack_public_path__ + "img/ios.cbd0a635.svg";